import React from 'react';
import { Flashbar } from 'AWS-UI-Components-React';
import {
  ERROR_MESSAGE,
} from '../../../constants/views';
import { extractErrorMessage } from '../../../utilities.js';

import { LOCAL_STORAGE_KEYS, saveToLocalStorage } from '../../../utils/local_storage';
import { accumulateProductLineById } from '../../../utils/product_line';

import { getJSClient } from '../../js_client';

import { GLPLMappingTable } from './gl_pl_mapping_table';

export class GLPLMapperContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      productLinesById: {},
      productGroupsById: {},
      rootProductLine: {},
      errorScreenMessage: null,
    };
  }

  componentWillMount = () => {
    this.client = getJSClient();
    this.initialClientTasks();
  };

  initialClientTasks = () => {
    this.refreshPlHierarchy();
    this.refreshGLProductGroups();
  };

  refreshGLProductGroups = () => {
    this.client.getGLProductGroups(this.onGLProductGroupPullSuccess, this.onGLProductGroupPullFailure);
  };

  refreshPlHierarchy = (id = 'ALL', version, successCallback, errorCallback) => {
    this.client.getPlHierarchy(
      successCallback || this.onPlHierarchyPullSuccess,
      errorCallback || this.onPlHierarchyPullFailure,
      {
        version: version || this.props.user,
        id,
      },
    );
  };

  onPlHierarchyPullSuccess = (data) => {
    const productLinesById = {};
    accumulateProductLineById(data.root, null, productLinesById);
    this.setState({ productLinesById, rootProductLine: data.root, errorScreenMessage: null });
  };

  onPlHierarchyPullFailure = (err) => {
    console.error(err);
    this.setState({ errorScreenMessage: extractErrorMessage(err) });
  };

  populateProductGroups = (productGroups) => {
    const productGroupsById = {};
    for (const productGroup of productGroups) {
      productGroupsById[productGroup.id] = productGroup;
    }

    this.setState({ productGroupsById });
  };

  onGLProductGroupPullSuccess = (data) => {
    this.populateProductGroups(data.glProductGroupList);
    saveToLocalStorage(LOCAL_STORAGE_KEYS.GL_PRODUCT_GROUPS, data.glProductGroupList);
    this.setState({ errorScreenMessage: null });
  };

  onGLProductGroupPullFailure = (err) => {
    console.error(err);
    this.setState({ errorScreenMessage: extractErrorMessage(err) });
  };

  render() {
    const { productLinesById, productGroupsById, errorScreenMessage } = this.state;

    return (
      <div>

        <div>
          <Flashbar
            items={
              errorScreenMessage
              ? [
                  {
                    type: 'error',
                    dismissible: true,
                    content: `${ERROR_MESSAGE}${errorScreenMessage}`,
                    dismiss: () => this.setState({ errorScreenMessage: null }),
                  },
                ]
              : []
            }
          />
        </div>

        <div className="awsui-util-container">
          <GLPLMappingTable productLinesById={productLinesById} productGroupsById={productGroupsById} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/config_central/gl_pl_mapping/gl_pl_container.jsx